import React, { Suspense } from 'react';

const AppModule = React.lazy(() => import('./AppModule'));

const App = React.memo(() => {

    return <Suspense fallback={<></>}>
      <AppModule />
    </Suspense>

});

export default App;